import React, { Fragment, useEffect,useState,useReducer } from "react";
import {connect} from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Row,Col,Card,Table,Button,Modal,Dropdown} from "react-bootstrap";
import ToastAlert from "../components/Magpie/ToastAlert";
import {useNavigate} from 'react-router-dom';
import PagePagination from "../components/Magpie/PagePagination";
import {getRoleAsync} from "../../store/actions/role.action";
import useAuthGetData from "../../hooks/useAuthGetData";


const LedgerHistory = ({roleFunc,roles,login,mount,orgSession}) => {

    const [message,setMessage] = useState("");
    const [status, setStatus] = useState(false);
    const [fired,setFired] = useState(false);
    const [peginateData, setPeginateData] = useState({});
    const navigate = useNavigate();
    const [btnLoad, setBtnLoad] = useState(false);
    const [btnDownload, setBtnDownload] = useState(false);
    const [scrHeight, setScrHeight] = useState('0px');
    const [ledger, setLedger] = useState({});
    const [filterDate, setFilterDate] = useState(new Date());

    const  HandleDimension = () => {
        const { innerWidth: width, innerHeight: height } = window;
        let avilHeight = Math.ceil((height/2))+'px'
        setScrHeight(height)
    }

    useEffect(() => {
        if(mount.status){
            if(login.isLogin){
                roleFunc()
                HandleDimension()
            }
            else{
                navigate("/login");
            }
        }
    }, [login,mount]);

    useEffect(() => {
        if(ledger.status){
            peginate(1,1000)
        }
    }, [ledger]);

    useEffect(() => {
        if(orgSession.status){
            setLedger({})
        }
    }, [orgSession]);

    const peginate = (page, perPage) => {
        let data = [];
        if(ledger.status && ledger.data.length > 0){
            let st = (page - 1) * perPage
            let chunk = page * perPage
            data =  ledger.data.slice(st, chunk);
        }
        setPeginateData(data)
    }

    const yesterday = () => {
        let currentDate = new Date()
        let yesterday = new Date(currentDate)
        return yesterday.setDate(yesterday.getDate() - 1)
    }

    const FilterData = async () => {
        setFired(false)
        setBtnLoad(true)
        const respond = await useAuthGetData('/ledger-data-history',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setBtnLoad(false)
        setLedger(respond)
        if(!respond.status){
            setFired(true)
            setMessage(respond.message)
            setStatus(respond.status)
        }
    }

    const DownloadFilterData = async () => {
        setFired(false)
        setBtnDownload(true)
        const respond = await useAuthGetData('/ledger-data-history-download',{company_id:orgSession.data.id, day:filterDate.toISOString().split('T')[0]});
        setBtnDownload(false)
        if(!respond.status){
            setFired(true)
            setMessage(respond.message)
            setStatus(respond.status)
        }else{
            const pdfUrl = '/reports/'+respond.data;
            const link = document.createElement("a");
            link.href = pdfUrl;
            link.download = respond.data;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <Fragment>
            <Row>
                {
                    fired ? <ToastAlert message={message} status={status} /> : ""
                }
                <Col lg={12} style={{minHeight:scrHeight}}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Ledger History</Card.Title>
                        </Card.Header>
                        <Card.Body>

                            <Row>

                                <Col sm={12} md={4} lg={4}>
                                    <DatePicker  dateFormat="yyyy-MM-dd" maxDate={yesterday()} className="form-control" selected={filterDate} onChange={(date) => setFilterDate(date)} />
                                </Col>
                                <Col sm={12} md={4} lg={4}>
                                    {
                                        !btnLoad ?
                                            <Button
                                                variant=""
                                                type="button"
                                                className="btn btn-primary w-100"
                                                onClick={FilterData}
                                            >
                                                Search
                                            </Button>
                                            :
                                            <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                    }
                                </Col>
                                <Col sm={12} md={4} lg={4}>
                                    {
                                        !btnDownload ?
                                            <Button
                                                variant=""
                                                type="button"
                                                className="btn btn-danger w-100"
                                                onClick={DownloadFilterData}
                                            >
                                                Download
                                            </Button>
                                            :
                                            <h1 className="la la-circle-o-notch la-spin me-2 text-primary " style={{fontSize:'40px'}} ></h1>
                                    }
                                </Col>
                            </Row>
                            <div className="mb-4"></div>
                            <Row>

                                <Col sm={12} md={12} lg={12}>
                                    {
                                        ledger.status ?
                                            <Table responsive className="header-border">
                                                <thead>
                                                <tr>
                                                    <th>Ledger Date</th>
                                                    <th>Customer</th>
                                                    <th>Debit</th>
                                                    <th>Credit</th>
                                                    <th>balance</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    peginateData.length > 0 ?
                                                        peginateData.map((row,i) => (
                                                            <Fragment key={i}>
                                                                <tr>
                                                                    <td style={{borderStyle:'dashed'}}>{row.ledger_date}</td>
                                                                    <td style={{borderStyle:'dashed'}}>{row.customer_name}</td>
                                                                    <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'D' ? row.transaction_amount : 0}</td>
                                                                    <td style={{borderStyle:'dashed'}} align="right">{row.transaction_type === 'C' ? row.transaction_amount : 0}</td>
                                                                    <td style={{borderStyle:'dashed'}}>{row.balance}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="6"> Comment : {row.comment}</td>
                                                                </tr>
                                                            </Fragment>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td>&nbsp;</td>
                                                        </tr>
                                                }
                                                </tbody>
                                            </Table>
                                            : ""
                                    }

                                    {
                                        ledger.status && ledger.data.length > 0 ?
                                            <div className="pt-2 m-l5">
                                                <PagePagination dataCount={ledger.data.length} perPage="1000" pegiFunction={peginate} />
                                            </div> : ""
                                    }
                                </Col>

                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );

}

const initMapStateToProps = state => ({
    login: state.auth,
    roles: state.roles,
    mount: state.mount,
    orgSession: state.orgSession

})

const initMapDispatchToProps = dispatch => ({
    roleFunc: () => dispatch(getRoleAsync()),
})

export default connect(initMapStateToProps,initMapDispatchToProps) (LedgerHistory)